<template>
  <div class="swimming_view">
    <div class="query_wapper">
      <div class="query_items">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
        <el-select
          style="margin:0 20px;"
          v-model="query.year"
          @change="getMatch"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          v-model="query.matchName"
          :popper-append-to-body="false"
          @change="$event=>getSignDetail($event)"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.matchName"
          ></el-option>
        </el-select>
      </div>
      <div class="query_items">
        <el-button type="warning" style="width:90px;margin:0 10px 0 20px" @click="print">打印</el-button>
        <!-- <el-button type="primary"  v-if="userInfo.type == 2" style="width:90px" @click="downExcel">下载</el-button> -->
      </div>
    </div>
    <template v-if="isShowData">
      <h1 v-if="switchType === 1" class='match_title'>{{details.matchName}}报名表</h1>
      <div v-if="switchType === 1" class="table_box">
        <table border="1" bordercolor="#ddd" cellspacing="0" cellpadding="0">
          <thead>
            <th
              v-for="(item,index) in columns"
              :key="index"
              :style="{width:item.width + 'px'}"
            >{{item.title}}</th>
          </thead>
          <tbody>
            <tr v-for="(item,index) in tableData" :key=" index">
              <td>{{index + 1}}</td>
              <template v-for="(temp,num) in columns.slice(1)">
                <td :key="num + '_' + index">{{getKey(temp.key,index)}}</td>
              </template>
            </tr>
          </tbody>
        </table>
        <div v-if="details.state === 0" style="height:150px;color:#444;padding:20px;">
          <section
            style="display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
          >
            <p style="font-size:24px">报名未提交</p>
            <el-button
              v-if="userInfo.type === 4"
              style="margin:20px 0 0 0"
              type="primary"
              @click="moveSubmit"
            >前往提交</el-button>
          </section>
        </div>
        <div v-else style="width:100%;height:100px;color:#444;padding:10px 20px;">
          <p style="font-size:14px;">体育部意见：</p>
          <p
            style="font-size:24px;text-align:center;margin-top:10px;"
          >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
        </div>
      </div>
      <athletesPhoto v-else :details="athleteList"></athletesPhoto>
      <div
        style="margin:30px 0 0 0;display:flex;justify-content:center;width:100%"
        v-if="switchType === 1 && details.state === 2 && userInfo.type === 4"
      >
        <el-button type="primary" @click="moveSubmit">前往修改</el-button>
      </div>
    </template>
    <template v-else>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <prints ref="prints" :details="details" :athleteList="athleteList" :year="query.year" :tableData="tableData" style='position:absolute;left:-100000px;top:-100000px'></prints>
  </div>
</template>
<script>
import { baseUrl } from "@/utils/config";
import prints from './components/prints';
import { getSession } from "@/utils/storage";
import { getSignListBySchool, signDetail } from "@/api/sign-up-match";
import { selectiveYear } from "@/common/js/mixins";
import athletesPhoto from "./components/athletes-photo";
export default {
  mixins: [selectiveYear],
    // 报名表查看
  components: {
    athletesPhoto,prints
  },
  data() {
    return {
      switchType: 1,
      query: {
        year: "",
        matchName: ""
      },
      athleteList:{},
      userInfo: JSON.parse(getSession("userInfo")),
      tableData: [],
      matchList: [],
      columns: [
        {
          title: "序号",
          width: 60
        },
        {
          title: "单位",
          width: 100,
          key: "schoolName"
        },
        {
          title: "身份",
          width: 100,
          key: "identity"
        },
        {
          title: "兼任",
          width: 100,
          key: "partTime"
        },
        {
          title: "性别",
          width: 60,
          key: "gender"
        },
        {
          title: "组别",
          width: 60,
          key: "group"
        },
        {
          title: "姓名",
          width: 100,
          key: "name"
        },
        {
          title: "姓名全拼",
          width: 160,
          key: "pinyin"
        },
        {
          title: "身份证号",
          width: 160,
          key: "idCard"
        },
        {
          title: "出生日期",
          width: 100,
          key: "birthday"
        },
        {
          title: "注册号码",
          width: 150,
          key: "registerNumber"
        },
        {
          title: "比赛号",
          width: 100,
          key: "matchNumber"
        },
        {
          title: "分计单位",
          width: 100,
          key: "subUnit"
        },
        {
          title: "教练",
          width: 80,
          key: "coachName"
        },
        {
          title: "备注",
          width: 80,
          key: "remarks"
        },
        {
          title: "距离",
          width: 80,
          key: "distance"
        },
        {
          title: "泳式",
          width: 100,
          key: "swimmingStyle"
        },
        {
          title: "报名成绩",
          width: 80,
          key: "score"
        },
        {
          title: "测验",
          width: 80,
          key: "test"
        },
        {
          title: "特殊标记",
          width: 80,
          key: "mark"
        }
      ],
      details: {},
      isShowData: true
    };
  },
  computed: {
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key && item.key !== 'identity') {
             keys = this.tableData[index][item.key];
          }
          else if(item.key === key && item.key === 'identity') {
            switch (this.tableData[index][item.key]){
              case 1:{
                keys = "运动员";
                break;
              }
              case 2:{
                keys = "教练";
                break;
              }
              case 3:{
                keys = "领队";
                break;
              }
              case 4:{
                keys = "工作人员";
                break;
              }
              case 5:{
                keys = "医生";
                break;
              }
              default:{
                keys = "代表队";
                break;
              }
            }
          }
        });
        
        return keys;
      };
    }
  },
  methods: {
    // 打印
    print(){
      this.$refs.prints.print();
    },
    // 下载
    downExcel(id){
      window.location.href = baseUrl + "/match/sign/getExcel?id=" + this.query.matchName;
    },
    selectType(switchType) {
      if(switchType === 2) {
        let arr = [];
        this.details.swimAthleteList.filter(item=>{
          if(item.identity === 1) {
            arr.push(item);
          }
        })
        this.athleteList = JSON.parse(JSON.stringify(this.details));
        this.$set(this.athleteList,'swimAthleteList',[...arr]);
        
      }
      this.switchType = switchType;
    },
    // 获取详情数据
    getSignDetail(id) {
      signDetail({ project: 4, id })
        .then(res => {
          if (!res) {
            res = { matchName: "" };
          }
          this.details = {...res};
          this.selectType(this.switchType);
          this.isShowData = true;
          this.hideMask = true;
          this.tableData = JSON.parse(JSON.stringify(res.swimAthleteList));
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowData = false;
          }
          this.hideMask = true;
        });
    },
    // 获取赛事列表
    getMatch() {
      getSignListBySchool({
        project: 4,
        year: this.$route.query.year ? this.$route.query.year : this.query.year
      })
        .then(res => {
          if (res.length > 0) {
            this.matchList = res;
            let id = res[0].id;
            if (this.$route.query.id) {
              res.filter(item => {
                if (item.matchId === this.$route.query.id) id = item.id;
              });
            }
            this.query.matchName = id;
            this.isShowBtn = true;
            this.getSignDetail(id);
          } else {
            this.matchList = [];
            this.query.matchName = "";
            this.isShowData = false;
            this.details = {};
          }
          this.hideMask = true;
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 前往提交
    moveSubmit() {
      let id = null;
      this.matchList.filter(item => {
        if (item.id === this.query.matchName) id = item.matchId;
      });
      this.$router.push({
        path: "/swimming/swimming-application-form",
        query: {
          id
        }
      });
    }
  },
  mounted() {
    this.getYearLists(this.query, this.getMatch);
  }
};
</script>
<style lang="less" scoped>
.swimming_view {
  .match_title {
    text-align: center;
    font-size: 24px;
    margin:40px 0 20px;
  }
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }
  .table_box {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    border: 1px solid #ddd;
    border-bottom: none;
  }
  table {
    width: 100%;
    table-layout: fixed;
    thead {
      th {
        color: #444;
        font-size: 16px;
        border-right: 1px solid #ddd;
        padding: 14px 0;
        border-bottom: 1px solid #ddd;
        &:last-of-type {
          border-right: none;
        }
      }
    }
    tbody {
      tr {
        td {
          text-align: center;
          font-size: 14px;
          color: #444;
          padding: 10px 0;
          border-right: 1px solid #ddd;
          word-break: break-all;
          vertical-align: middle;
          border-bottom: 1px solid #ddd;
          &:last-of-type {
            border-right: none;
          }
        }
      }
    }
  }
}
</style>